module.exports = __webpack_public_path__ + "img/dfid.ad79dbe1.png";